import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oficina-main',
  templateUrl: './oficina-main.component.html',
  styleUrls: ['./oficina-main.component.scss']
})
export class OficinaMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
